// Attendre que le DOM soit complètement chargé avant d'exécuter le script
document.addEventListener('DOMContentLoaded', () => {
	const headerNavButton = document.querySelector('.header__nav button');
	const headerFixedButton = document.querySelector('.header-fixed__nav button');
	const nav = document.querySelector('.nav');
	const closeButton = nav?.querySelector('.nav__close');

	if (!headerNavButton || !nav) return;

	// Sélection des éléments focusables dans la modale
	const getFocusableElements = () =>
		nav.querySelectorAll(
			'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
		);

	let lastFocusedElement = null;

	/**
	 * Gestion des liens et sous menus
	 */
	// Sélectionne tous les liens parents qui ont un sous-menu
	const parentLinks = document.querySelectorAll(
		'.menu__item.has-children > .menu__link[aria-haspopup="true"]'
	);

	parentLinks.forEach((link) => {
		const submenu = link.nextElementSibling; // le <ul.menu__submenu> juste après

		const toggleSubmenu = (e) => {
			e.preventDefault(); // empêche la navigation si href="#"
			const isOpen = link.getAttribute('aria-expanded') === 'true';

			// 🔹 Fermer tous les autres sous-menus
			parentLinks.forEach((otherLink) => {
				otherLink.setAttribute('aria-expanded', 'false');
				if (otherLink.nextElementSibling) {
					otherLink.nextElementSibling.hidden = true;
				}
			});

			// 🔹 Ouvrir/fermer celui cliqué
			link.setAttribute('aria-expanded', String(!isOpen));
			submenu.hidden = isOpen;
		};

		// Clic souris
		link.addEventListener('click', toggleSubmenu);

		// Activation clavier (Entrée ou Espace)
		link.addEventListener('keydown', (e) => {
			if (e.key === 'Enter' || e.key === ' ') {
				toggleSubmenu(e);
			}
			if (e.key === 'Escape') {
				link.setAttribute('aria-expanded', 'false');
				submenu.hidden = true;
				link.focus();
			}
		});

		// Fermeture si clic en dehors
		document.addEventListener('click', (e) => {
			if (!link.parentElement.contains(e.target)) {
				link.setAttribute('aria-expanded', 'false');
				submenu.hidden = true;
			}
		});
	});
	/**
	 * Fin gestion des liens et sous menus
	 */

	// Fonction d'ouverture
	const openNav = () => {
		lastFocusedElement = document.activeElement; // Sauvegarde l'élément qui avait le focus
		nav.hidden = false;
		nav.classList.add('nav--is-open');
		headerNavButton.setAttribute('aria-expanded', 'true');

		// Rendre le contenu du menu accessible
		nav.removeAttribute('aria-hidden');
		getFocusableElements().forEach((el) => el.removeAttribute('tabindex'));

		// Focus sur le premier élément focusable
		const focusables = getFocusableElements();
		if (focusables.length) focusables[0].focus();

		document.body.classList.add('no-scroll'); // 🔒 Bloque le scroll
		document.addEventListener('keydown', trapFocus);
		document.addEventListener('keydown', handleEscClose);
	};

	// Fonction de fermeture
	const closeNav = () => {
		nav.hidden = true;
		nav.classList.remove('nav--is-open');
		headerNavButton.setAttribute('aria-expanded', 'false');

		// Rendre le contenu du menu inaccessible
		nav.setAttribute('aria-hidden', 'true');
		getFocusableElements().forEach((el) => el.setAttribute('tabindex', '-1'));

		// Rendre le focus à l'élément déclencheur
		if (lastFocusedElement) lastFocusedElement.focus();

		document.body.classList.remove('no-scroll'); // 🔓 Réactive le scroll
		document.removeEventListener('keydown', trapFocus);
		document.removeEventListener('keydown', handleEscClose);
	};

	// Gestion du focus trap
	const trapFocus = (e) => {
		if (e.key !== 'Tab') return;

		const focusables = Array.from(getFocusableElements());
		const firstEl = focusables[0];
		const lastEl = focusables[focusables.length - 1];

		if (e.shiftKey && document.activeElement === firstEl) {
			e.preventDefault();
			lastEl.focus();
		} else if (!e.shiftKey && document.activeElement === lastEl) {
			e.preventDefault();
			firstEl.focus();
		}
	};

	// Fermeture avec la touche Esc
	const handleEscClose = (e) => {
		if (e.key === 'Escape') {
			closeNav();
		}
	};

	// Fonction toggle commune
	const toggleNav = () => {
		const isOpen = nav.classList.contains('nav--is-open');
		isOpen ? closeNav() : openNav();
	};

	// Ouverture/fermeture via le bouton burger
	headerNavButton.addEventListener('click', toggleNav);

	// Ouverture/fermeture via le bouton header-fixed
	headerFixedButton?.addEventListener('click', toggleNav);

	// Fermeture via le bouton "X"
	closeButton?.addEventListener('click', closeNav);
});
